import { render, staticRenderFns } from "./NewSizedList.vue?vue&type=template&id=0191187d&scoped=true&"
import script from "./NewSizedList.vue?vue&type=script&lang=js&"
export * from "./NewSizedList.vue?vue&type=script&lang=js&"
import style0 from "./NewSizedList.vue?vue&type=style&index=0&id=0191187d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0191187d",
  null
  
)

export default component.exports